import styled from 'styled-components'
import { Section, Title, Description } from './globalStyles'
import { media } from './globalStyles'

export const AboutSection = styled(Section)`
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    padding: 0 11.7862%;
    ${media.lessThan('desktop15')`
      padding: 0 10%;
    `};
    ${media.lessThan('miniTablet')`
      padding: 0 8.5rem 0 3.25rem;
    `};
    ${media.lessThan('phone')`
      padding: 6rem 1.5625rem 3rem;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`
export const AboutWrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: auto;
  min-height: 100%;
  color: black;
`

export const AboutTitle = styled(Title)`
  margin-bottom: 2.5rem;
  ${media.lessThan('phone')`
    margin-bottom: 1.5rem;
  `}
`
export const AboutDescription = styled(Description)`
  max-width: 60%;
  p {
    a {
      color: ${(props) => props.theme.darkBlue};
      ${media.greaterThan('phone')`
        transition: all 300ms;
        transition-property: color;
        will-change: color;
        &:hover {
          color: ${(props) => props.theme.blue};
        }
      `}
    }
  }
  ${media.lessThan('desktop15')`
    max-width: 68%;
  `};
  ${media.lessThan('miniTablet')`
    max-width: none;
  `};
`
